import { render, staticRenderFns } from "./SignDetailsDialog.vue?vue&type=template&id=795b3a6e&scoped=true&"
import script from "./SignDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./SignDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./SignDetailsDialog.vue?vue&type=style&index=0&id=795b3a6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b3a6e",
  null
  
)

export default component.exports